// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import CasavioLogo from './shared/CasavioLogo'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', brown: '#2C1D14', muted: '#9A7B68',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const sections = [
  {
    n: 1, title: 'INTRODUCTION',
    body: `Casavio ("we," "our," or "us") is a home management platform operated by Casavio, LLC. This Privacy Policy explains how we collect, use, store, and protect your personal information when you use our application at casavio-app.vercel.app (the "Service").

By using Casavio, you agree to the collection and use of information in accordance with this policy.`,
  },
  {
    n: 2, title: 'INFORMATION WE COLLECT',
    body: `Information You Provide Directly:
• Account information: first name, last name, email address, phone number, and password
• Property information: home address, city, state, zip code, property type, year built, square footage, bedrooms, and bathrooms
• Appliance information: make, model, serial number, purchase date, and notes for appliances and home systems you add
• Documents: files and photos you upload to your home profile
• Maintenance records: task completion dates, costs, and notes you log

Information We Collect Automatically:
• Usage data: pages visited, features used, and actions taken within the app
• Device information: browser type, operating system, and IP address
• Authentication tokens: secure session tokens to keep you logged in`,
  },
  {
    n: 3, title: 'HOW WE USE YOUR INFORMATION',
    body: `We use your information to:
• Provide and maintain the Casavio Service
• Generate personalized maintenance schedules for your appliances and home systems
• Send maintenance reminders and notifications via email
• Automatically look up owner's manuals for your appliances using AI
• Improve and develop new features
• Communicate with you about your account and the Service
• Comply with legal obligations`,
  },
  {
    n: 4, title: 'AI-POWERED FEATURES',
    body: `Casavio uses Claude, an AI assistant developed by Anthropic, PBC, to power certain features including:
• Automatic owner's manual lookup: when you add an appliance, we send the make and model to Anthropic's API to find the relevant manual
• Future features may include AI-generated maintenance recommendations

When these features are used, your appliance make and model information is sent to Anthropic's servers. We do not send your personal identifying information (name, address, email) to Anthropic. Anthropic's use of this data is governed by their Privacy Policy at anthropic.com/privacy.`,
  },
  {
    n: 5, title: 'PHOTO METADATA',
    body: `When you upload a photo to Casavio, we strip all metadata embedded in the photo file before storage. This includes:
• Location coordinates (GPS)
• Date and time the photo was taken
• Device information (camera make, model, software version)
• Any other metadata embedded by the camera or photo app

Only the visual content of the photo is retained. The original metadata is never stored, transmitted to third parties, or visible in our system after upload.`,
  },
  {
    n: 6, title: 'DATA STORAGE AND SECURITY',
    body: `Your data is stored securely using Supabase, a cloud database platform. We implement industry-standard security measures including:
• Encrypted data transmission (HTTPS/TLS)
• Row-level security ensuring you can only access your own data
• Secure authentication via Supabase Auth
• Regular security updates

While we take reasonable precautions, no method of transmission over the Internet is 100% secure. We cannot guarantee absolute security of your data.`,
  },
  {
    n: 7, title: 'EMAIL COMMUNICATIONS',
    body: `We use Resend, an email delivery service, to send:
• Maintenance reminders and schedules
• Account notifications
• Product updates (with your consent)

You can opt out of non-essential emails at any time through your Settings. Transactional emails related to your account cannot be disabled.`,
  },
  {
    n: 8, title: 'DATA SHARING',
    body: `We do not sell your personal information. We share data only with:
• Service providers: Supabase (database), Anthropic (AI features), Resend (email), and Vercel (hosting) — only as necessary to provide the Service
• Legal requirements: if required by law, court order, or governmental authority
• Business transfers: in connection with a merger, acquisition, or sale of assets`,
  },
  {
    n: 9, title: 'DATA RETENTION',
    body: `We retain your data as long as your account is active. You may request deletion of your account and associated data by contacting us at privacy@casavio.app. Some data may be retained as required by law or for legitimate business purposes.`,
  },
  {
    n: 10, title: 'YOUR RIGHTS',
    body: `You have the right to:
• Access the personal information we hold about you
• Correct inaccurate information
• Request deletion of your account and data
• Opt out of non-essential communications
• Data portability (receive a copy of your data)

To exercise these rights, contact us at privacy@casavio.app.`,
  },
  {
    n: 11, title: "CHILDREN'S PRIVACY",
    body: `Casavio is not intended for use by children under 13 years of age. We do not knowingly collect personal information from children under 13.`,
  },
  {
    n: 12, title: 'CALIFORNIA PRIVACY RIGHTS',
    body: `If you are a California resident, you have additional rights under the California Consumer Privacy Act (CCPA), including the right to know what personal information is collected, the right to delete personal information, and the right to opt-out of the sale of personal information. We do not sell personal information. To exercise your California privacy rights, contact privacy@casavio.app.`,
  },
  {
    n: 13, title: 'CHANGES TO THIS POLICY',
    body: `We may update this Privacy Policy from time to time. We will notify you of significant changes by email or by posting a notice within the app. Your continued use of Casavio after changes are posted constitutes acceptance of the updated policy.`,
  },
  {
    n: 14, title: 'CONTACT US',
    body: `If you have questions about this Privacy Policy, please contact us at:
Casavio, LLC
privacy@casavio.app
casavio-app.vercel.app`,
  },
]

export default function PrivacyPolicy() {
  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: fs }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '48px 24px 80px' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <CasavioLogo size={26} color={C.amber} style={{ justifyContent: 'center', marginBottom: '8px' }} />
          <div style={{ fontFamily: f, fontSize: '24px', color: C.brown, marginBottom: '6px' }}>Privacy Policy</div>
          <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs }}>Last Updated: May 31, 2026</div>
        </div>

        {/* Back link */}
        <div style={{ marginBottom: '32px' }}>
          <a href="/" style={{ fontSize: '13px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>
            ← Back to App
          </a>
        </div>

        {/* Sections */}
        {sections.map(s => (
          <div key={s.n} style={{ marginBottom: '32px', background: C.card, borderRadius: '12px', padding: '24px', border: `1px solid ${C.border}` }}>
            <div style={{ fontFamily: f, fontSize: '15px', fontWeight: '700', color: C.amber, marginBottom: '12px', letterSpacing: '0.5px' }}>
              {s.n}. {s.title}
            </div>
            <div style={{ fontSize: '14px', color: C.brown, lineHeight: '1.8', whiteSpace: 'pre-line', fontFamily: fs }}>
              {s.body}
            </div>
          </div>
        ))}

        {/* Footer */}
        <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: '24px', textAlign: 'center' }}>
          <CasavioLogo size={14} color={C.amber} style={{ justifyContent: 'center', marginBottom: '12px' }} />
          <div style={{ display: 'flex', justifyContent: 'center', gap: '24px', flexWrap: 'wrap', marginBottom: '8px' }}>
            <a href="/privacy" style={{ fontSize: '12px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>Privacy Policy</a>
            <a href="/terms" style={{ fontSize: '12px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>Terms of Service</a>
            <a href="mailto:support@casavio.app" style={{ fontSize: '12px', color: C.amber, textDecoration: 'none', fontFamily: fs }}>Contact Support</a>
          </div>
          <div style={{ fontSize: '11px', color: C.muted, fontFamily: fs }}>© 2026 Casavio, LLC. All rights reserved.</div>
        </div>

      </div>
    </div>
  )
}
